<div class="container">
  <div class="celo-dialog-header">
    <h2 class="mat-h2">Edit Details</h2>
    <button
      mat-icon-button
      class="celo-dialog-close"
      aria-label="Close"
      id="close"
      mat-dialog-close
    >
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <app-patient-details-form
    [lastName]="data?.patientDetails?.lastName ?? ''"
    [firstName]="data?.patientDetails?.firstName ?? ''"
    [dateOfBirth]="data?.patientDetails?.dateOfBirth ?? ''"
    [phoneNumber]="data?.patientDetails?.phoneNumber ?? ''"
    [disabled]="isSubmitting"
    (patientDetails)="onSubmit($event)"
    (isValid)="isPatientDetailsValid = $event"
    #patientDetailsForm
  >
    <div class="flex justify-end g-10px">
      <button
        mat-button
        class="celo-secondary-button uppercase"
        type="button"
        mat-dialog-close=""
      >
        Cancel
      </button>

      <button
        mat-button
        class="celo-primary-button uppercase"
        type="submit"
        [disabled]="!isPatientDetailsValid || isSubmitting"
      >
        @if (!isSubmitting) {
          Save
        } @else {
          <mat-icon>
            <app-basic-spinner
              diameter="20"
              strokeWidth="2"
            ></app-basic-spinner>
          </mat-icon>
        }
      </button>
    </div>
  </app-patient-details-form>
</div>
